import { cn as e } from "../shared/utils.js";
import { Button as t } from "../button/primitive/button.js";
import { useTranslation as n } from "../i18n/hooks.js";
import { BottomDrawer as r } from "../bottom-drawer/index.js";
import { useAdaptiveOverlay as i } from "../shared/hooks/use-adaptive-overlay.js";
import { ComboboxVirtualizedList as a } from "./virtualized-list.js";
import { ComboboxPrimitive as o, comboboxTriggerVisualVariants as s } from "./combobox-primitive.js";
import { PlusCircleIcon as c, XCloseIcon as l } from "@systemeio/icons";
import { createContext as u, forwardRef as d, useCallback as f, useContext as p, useLayoutEffect as m, useMemo as h, useReducer as g, useRef as _, useState as v } from "react";
import { Fragment as y, jsx as b, jsxs as x } from "react/jsx-runtime";
import { createPortal as S } from "react-dom";
//#region src/combobox/combobox.tsx
var C = u(null), w = u(null), T = u(!1);
function E() {
	return p(C);
}
var D = d(({ className: e, children: t, ...n }, i) => /* @__PURE__ */ b(r.Footer, {
	...n,
	ref: i,
	"data-slot": "combobox-drawer-footer",
	className: e,
	children: /* @__PURE__ */ b("div", {
		className: "flex w-full *:min-w-[90px] *:flex-1",
		children: t
	})
}));
D.displayName = "Combobox.DrawerFooterChrome";
function O({ children: e }) {
	let t = _(null), [n, r] = v(0), i = f(() => (r((e) => e + 1), () => r((e) => e - 1)), []), a = h(() => ({
		footerRef: t,
		registerDrawerFooter: i
	}), [i]);
	return /* @__PURE__ */ b(w.Provider, {
		value: a,
		children: /* @__PURE__ */ b(T.Provider, {
			value: n > 0,
			children: e
		})
	});
}
function k({ children: e, placeholder: t, disabled: n = !1, size: a = "md", multiple: s, value: c, defaultValue: l, onValueChange: u, open: d, defaultOpen: p = !1, onOpenChange: m, searchValue: g, defaultSearchValue: y, onSearchChange: x, inputValue: S, defaultInputValue: w, onInputValueChange: T, drawerTitle: E, align: D = "end", "aria-label": k, filter: A, itemToStringLabel: j, items: M, virtualized: N, ...P }) {
	let F = !!s, I = d !== void 0, [L, R] = v(p), z = I ? d : L, B = _(l ?? (F ? [] : null)), V = g ?? S, H = y ?? w, U = f((e, t) => {
		m?.(e, t), !t?.isCanceled && (I || R(e));
	}, [I, m]), W = f((e, t) => {
		u?.(e, t), t.isCanceled || (B.current = e);
	}, [u]), G = f((e, t) => {
		x?.(e), T?.(e, t);
	}, [x, T]), K = i(!!z, U), q = h(() => ({
		isMobile: K,
		multiple: F,
		placeholder: t,
		disabled: !!n,
		size: a,
		ariaLabel: k,
		drawerTitle: E,
		align: D,
		virtualized: !!N
	}), [
		K,
		F,
		t,
		n,
		a,
		k,
		E,
		D,
		N
	]), J = K ? /* @__PURE__ */ b(r.Root, {
		open: z,
		onOpenChange: (e) => U(e),
		children: e
	}) : e, Y = `${K ? "mobile" : "desktop"}:${N ? "virtualized" : "plain"}`;
	return /* @__PURE__ */ b(C.Provider, {
		value: q,
		children: /* @__PURE__ */ b(O, { children: /* @__PURE__ */ b(o.Root, {
			...P,
			multiple: s,
			filter: A,
			items: M,
			virtualized: N,
			value: c,
			defaultValue: B.current,
			onValueChange: W,
			open: z,
			onOpenChange: U,
			disabled: n,
			inputValue: V,
			defaultInputValue: H,
			onInputValueChange: G,
			modal: !K && P.modal,
			inline: K || P.inline,
			itemToStringLabel: j,
			children: J
		}, Y) })
	});
}
k.displayName = "Combobox";
var A = d(({ className: t, placeholder: n, "aria-label": r, ...i }, a) => {
	let s = E(), c = n ?? s?.placeholder, l = r ?? s?.ariaLabel;
	return s?.isMobile ? s.multiple ? /* @__PURE__ */ b("span", {
		...i,
		ref: a,
		"data-slot": "combobox-input",
		"data-testid": "combobox-input",
		className: e("text-text-tertiary min-w-0 flex-1 text-base", t),
		children: c
	}) : /* @__PURE__ */ b(o.Value, {
		...i,
		ref: a,
		placeholder: c,
		className: e("group-data-placeholder/combobox-group:text-text-tertiary", t)
	}) : /* @__PURE__ */ b(o.Input, {
		...i,
		ref: a,
		className: t,
		placeholder: c,
		disabled: s?.disabled,
		"aria-label": l
	});
});
A.displayName = "Combobox.Input";
var j = d(({ className: t, onClick: n, size: r, ...i }, a) => {
	let s = E(), c = r ?? s?.size;
	return /* @__PURE__ */ b("div", {
		className: e("relative w-full min-w-0", s?.isMobile && !s.disabled && "cursor-pointer", "[&_[data-slot=combobox-chip-remove]]:relative [&_[data-slot=combobox-chip-remove]]:z-20", "[&_[data-slot=combobox-clear]]:relative [&_[data-slot=combobox-clear]]:z-20"),
		children: /* @__PURE__ */ b(o.InputGroup, {
			...i,
			ref: a,
			size: c,
			className: e(s?.isMobile && !s.disabled && "cursor-pointer", t),
			onClick: n
		})
	});
});
j.displayName = "Combobox.InputGroup";
var M = d((e, t) => {
	let n = E(), { layout: r = "fixed-height", ...i } = e;
	if (!n) throw Error("Combobox.Chips must be used inside Combobox.Root");
	if (!n.multiple) throw Error("Combobox.Chips requires Combobox.Root multiple");
	if ("mode" in i) throw Error("Combobox.Chips owns adaptive layout; use layout or ComboboxPrimitive.Chips for custom modes");
	return /* @__PURE__ */ b(o.Chips, {
		...i,
		ref: t,
		mode: r === "expanded" ? "expanded" : "fixed"
	});
});
M.displayName = "Combobox.Chips";
var N = d(({ className: t, children: n, disabled: i, "aria-label": a, ...c }, l) => {
	let u = E(), d = i || u?.disabled, f = a ?? u?.ariaLabel ?? u?.placeholder;
	return u?.isMobile ? /* @__PURE__ */ x(y, { children: [/* @__PURE__ */ b(r.Trigger, {
		...c,
		ref: l,
		"data-adaptive-overlay": "drawer",
		disabled: d,
		"aria-label": f,
		"data-slot": "combobox-trigger",
		"data-testid": "combobox-trigger",
		render: (e, t) => /* @__PURE__ */ b("button", {
			...e,
			"data-combobox-open": t.open ? "" : void 0,
			type: "button"
		}),
		className: "focus-visible:ring-field-border-active absolute inset-0 z-10 cursor-pointer rounded-md outline-none focus-visible:ring-2 disabled:cursor-not-allowed"
	}), /* @__PURE__ */ b("span", {
		"aria-hidden": !0,
		"data-slot": "combobox-trigger-visual",
		className: e(s(), t),
		children: n
	})] }) : /* @__PURE__ */ b(o.Trigger, {
		...c,
		ref: l,
		disabled: d,
		"aria-label": f,
		className: t,
		children: n
	});
});
N.displayName = "Combobox.Trigger";
function P({ multiple: e }) {
	let i = p(w), a = p(T), { t: o } = n();
	return i ? /* @__PURE__ */ b("div", {
		ref: i.footerRef,
		className: "contents",
		children: e && !a ? /* @__PURE__ */ b(D, {
			"data-default-footer": "",
			children: /* @__PURE__ */ b(r.Close, {
				render: /* @__PURE__ */ b(t, { variant: "primary" }),
				children: o("public_pages_purchase.form_select.done")
			})
		}) : null
	}) : null;
}
function F({ context: n, children: i }) {
	return /* @__PURE__ */ x(r.Popup, { children: [
		n.drawerTitle ? /* @__PURE__ */ b(r.Header, { children: /* @__PURE__ */ x("div", {
			className: "flex w-full items-start gap-2.5",
			children: [/* @__PURE__ */ b(r.Title, {
				className: "min-w-0 flex-1",
				children: n.drawerTitle
			}), /* @__PURE__ */ b(r.Close, {
				"aria-label": "Close",
				render: /* @__PURE__ */ b(t, {
					variant: "ghost-gray",
					size: "icon-sm"
				}),
				children: /* @__PURE__ */ b(l, { className: "text-icon-primary size-[18px]" })
			})]
		}) }) : /* @__PURE__ */ b(r.Title, {
			className: "sr-only",
			children: n.ariaLabel ?? "Select"
		}),
		/* @__PURE__ */ b(r.Content, {
			className: e("gap-4 px-0 pt-4 pb-2", n.virtualized && "min-h-0 flex-1 overflow-hidden [&>[data-slot=combobox-list]]:min-h-0 [&>[data-slot=combobox-list]]:flex-1 [&>[data-slot=combobox-list]]:shrink"),
			children: i
		}),
		/* @__PURE__ */ b(P, { multiple: n.multiple })
	] });
}
var I = d(({ className: t, children: n, ...r }, i) => {
	let a = E();
	if (!a) throw Error("Combobox.Content must be used inside Combobox.Root");
	let s = /* @__PURE__ */ b(o.List, {
		...r,
		ref: i,
		"data-slot": "combobox-list",
		className: e("flex w-full flex-col", a.virtualized && "min-h-0 overflow-hidden", a.isMobile && !a.virtualized && "overflow-y-visible overscroll-auto", t),
		children: n
	});
	return a.isMobile ? /* @__PURE__ */ x(F, {
		context: a,
		children: [/* @__PURE__ */ b("div", {
			className: "px-4",
			children: /* @__PURE__ */ b(o.Input, {
				autoFocus: !0,
				"data-slot": "combobox-drawer-search",
				placeholder: a.placeholder,
				disabled: a.disabled,
				"aria-label": a.ariaLabel ?? a.placeholder
			})
		}), s]
	}) : /* @__PURE__ */ b(o.Portal, { children: /* @__PURE__ */ b(o.Positioner, {
		align: a.align,
		className: "z-50",
		sideOffset: 4,
		children: /* @__PURE__ */ b(R, { children: s })
	}) });
});
I.displayName = "Combobox.Content";
function L({ children: e }) {
	let t = E();
	if (typeof e != "function") throw Error("Combobox.List requires a function child that renders each Root item");
	return t?.virtualized ? /* @__PURE__ */ b(a, { children: e }) : /* @__PURE__ */ b(o.Collection, { children: e });
}
L.displayName = "Combobox.List";
var R = d((e, t) => /* @__PURE__ */ b(o.Popup, {
	...e,
	ref: t
}));
R.displayName = "Combobox.Popup";
var z = d(({ value: e, disabled: t, className: n, children: r, label: i, index: a, ...s }, c) => {
	let l = E(), u = i ?? r;
	return /* @__PURE__ */ x(o.Item, {
		...s,
		ref: c,
		value: e,
		disabled: t,
		className: n,
		index: a,
		children: [
			l?.multiple ? /* @__PURE__ */ b(o.ItemIndicator, {
				keepMounted: !0,
				className: "contents",
				render: (e, t) => /* @__PURE__ */ b("span", {
					...e,
					children: /* @__PURE__ */ b(o.ItemCheckbox, { checked: t.selected })
				})
			}) : null,
			/* @__PURE__ */ b(o.ItemText, { children: u }),
			l?.multiple ? null : /* @__PURE__ */ b(o.ItemIndicator, {})
		]
	});
});
z.displayName = "Combobox.Option";
var B = d(({ value: e, disabled: n, className: r, children: i, label: a, index: s, ...l }, u) => /* @__PURE__ */ x(o.Item, {
	...l,
	ref: u,
	value: e,
	disabled: n,
	className: r,
	index: s,
	nativeButton: !0,
	"data-create": "",
	render: /* @__PURE__ */ b(t, {
		size: "md",
		variant: "ghost-color",
		className: "w-full justify-start"
	}),
	children: [/* @__PURE__ */ b(c, {}), a ?? i]
}));
B.displayName = "Combobox.CreateOptionRow";
var V = d((e, t) => {
	let n = o.useFilteredItems();
	return /* @__PURE__ */ b(B, {
		...e,
		ref: t,
		index: n.length
	});
});
V.displayName = "Combobox.VirtualizedCreateOption";
var H = d((e, t) => E()?.virtualized && e.index == null ? /* @__PURE__ */ b(V, {
	...e,
	ref: t
}) : /* @__PURE__ */ b(B, {
	...e,
	ref: t
}));
H.displayName = "Combobox.CreateOption";
var U = d((e, t) => /* @__PURE__ */ b(o.Group, {
	...e,
	ref: t
}));
U.displayName = "Combobox.Group";
var W = d((e, t) => /* @__PURE__ */ b(o.GroupLabel, {
	...e,
	ref: t
}));
W.displayName = "Combobox.GroupLabel";
function G(e) {
	return /* @__PURE__ */ b(o.Collection, { ...e });
}
G.displayName = "Combobox.GroupOptions";
var K = d((e, t) => /* @__PURE__ */ b(o.Status, {
	...e,
	ref: t
}));
K.displayName = "Combobox.Status";
var q = d((e, t) => /* @__PURE__ */ b(o.Empty, {
	...e,
	ref: t
}));
q.displayName = "Combobox.Empty";
var J = d(({ className: e, children: t, ...n }, r) => {
	let i = E(), a = p(w), [, o] = g((e) => e + 1, 0);
	if (m(() => {
		o();
	}, []), m(() => {
		if (a) return a.registerDrawerFooter();
	}, [a]), !i?.isMobile) return null;
	let s = /* @__PURE__ */ b(D, {
		...n,
		ref: r,
		className: e,
		"data-consumer-drawer-footer": "",
		children: t
	}), c = a?.footerRef.current;
	return c ? S(s, c) : s;
});
J.displayName = "Combobox.DrawerFooter";
//#endregion
export { M as ComboboxChips, I as ComboboxContent, H as ComboboxCreateOption, J as ComboboxDrawerFooter, q as ComboboxEmpty, U as ComboboxGroup, W as ComboboxGroupLabel, G as ComboboxGroupOptions, A as ComboboxInput, j as ComboboxInputGroup, L as ComboboxList, z as ComboboxOption, k as ComboboxRoot, K as ComboboxStatus, N as ComboboxTrigger };
